/*
 * dev-link-rewrite.js
 * 在本地开发/预览环境下，将指向商店线上域名的绝对链接重写为当前开发域，从而避免跳转到原网站。
 * 使用场景：菜单项在后台保存为完整URL（如 https://www.example.com/...），但本地开发希望保留在预览域。
 *
 * 安全与控制：
 * - 默认仅在 localhost/127.0.0.1 或端口为 8080 的环境启用，也可通过查询参数 ?devLinkRewrite=1 强制启用。
 * - 可设置 window.__DISABLE_DEV_LINK_REWRITE__ = true 关闭。
 * - 设置 localStorage.devLinkRewriteDebug = '1' 开启调试日志。
 */

(function () {
  'use strict';

  // 配置与开关
  var DISABLE_FLAG = typeof window.__DISABLE_DEV_LINK_REWRITE__ !== 'undefined' ? !!window.__DISABLE_DEV_LINK_REWRITE__ : false;
  var DEBUG = (typeof localStorage !== 'undefined' && localStorage.getItem('devLinkRewriteDebug') === '1');

  function log() {
    if (!DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[dev-link-rewrite]');
    try { console.log.apply(console, args); } catch (e) {}
  }

  function isDevEnv() {
    try {
      var loc = window.location;
      if (/devLinkRewrite=1/.test(loc.search)) return true;
      if (DISABLE_FLAG) return false;
      var host = loc.hostname;
      var port = String(loc.port || '');
      if (host === 'localhost' || host === '127.0.0.1') return true;
      if (port === '8080') return true;
      return false;
    } catch (e) {
      return false;
    }
  }

  if (!isDevEnv()) {
    log('Not in dev env — rewrite disabled');
    return;
  }

  // 收集可能的“商店线上域”以便识别需要重写的链接
  function collectShopDomains() {
    var domains = new Set();
    try {
      // 当前域（开发域）也加入参考集合，但我们不重写同域链接
      domains.add(window.location.hostname);

      // Shopify 全局（myshopify 域）
      if (window.Shopify && typeof window.Shopify.shop === 'string') {
        try { domains.add(new URL('https://' + window.Shopify.shop).hostname); } catch (e) {}
      }

      // canonical 链接（主题通常会注入）
      var canonical = document.querySelector('link[rel="canonical"]');
      if (canonical && canonical.href) {
        try { domains.add(new URL(canonical.href).hostname); } catch (e) {}
      }

      // og:url 作为补充
      var og = document.querySelector('meta[property="og:url"]');
      if (og && og.content) {
        try { domains.add(new URL(og.content).hostname); } catch (e) {}
      }

      // 可选：开发者自定义主域（若你在其他脚本里设置了）
      if (typeof window.__SHOP_PRIMARY_DOMAIN__ === 'string') {
        try { domains.add(new URL('https://' + window.__SHOP_PRIMARY_DOMAIN__).hostname); } catch (e) {}
      }

    } catch (e) {
      // 忽略收集错误
    }
    return domains;
  }

  var shopDomains = collectShopDomains();
  var currentOrigin = window.location.origin;

  function shouldRewrite(anchor) {
    try {
      // 显式禁止：data-dev-rewrite="false"
      if (anchor.getAttribute('data-dev-rewrite') === 'false') return false;
      var href = anchor.getAttribute('href');
      if (!href) return false;
      // 只处理 http/https 绝对链接
      if (!/^https?:\/\//i.test(href)) return false;

      var url = new URL(href);
      // 同域链接无需重写
      if (url.origin === currentOrigin) return false;

      // 仅当链接指向“商店相关域”时重写，避免社交媒体等外链被误改
      if (shopDomains.has(url.hostname)) return true;
      return false;
    } catch (e) {
      return false;
    }
  }

  function rewriteHref(href) {
    try {
      var url = new URL(href);
      var rewritten = currentOrigin + url.pathname + url.search + url.hash;
      return rewritten;
    } catch (e) {
      return href;
    }
  }

  function processAnchor(anchor) {
    var href = anchor.getAttribute('href');
    if (!href) return;
    if (!shouldRewrite(anchor)) return;
    var newHref = rewriteHref(href);
    if (newHref && newHref !== href) {
      anchor.setAttribute('href', newHref);
      log('Rewrote:', href, '=>', newHref);
    }
  }

  function rewriteAll(container) {
    var scope = container || document;
    var anchors = scope.querySelectorAll('a[href]');
    anchors.forEach(processAnchor);
  }

  // 初始执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { rewriteAll(document); });
  } else {
    rewriteAll(document);
  }

  // 监听后续 DOM 变更（菜单展开、异步渲染）
  try {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (!m.addedNodes || !m.addedNodes.length) return;
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return; // 仅元素节点
          if (node.tagName && node.tagName.toLowerCase() === 'a') {
            processAnchor(node);
          } else {
            rewriteAll(node);
          }
        });
      });
    });
    observer.observe(document.documentElement || document.body, {
      childList: true,
      subtree: true
    });
    log('MutationObserver attached');
  } catch (e) {
    log('MutationObserver failed:', e && e.message);
  }
})();

